import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { WarningIcon } from '@issuemanager/apps/client/components';

type Props = {
  value?: number;
};

export function IssueGridSLAColumn({ value }: Props) {
  const semantic = useAtlasSemanticThemeTokens();
  const { t } = useTranslation(['common', 'issue']);

  if (value == null) {
    return null;
  }

  return (
    <Box alignItems='center' data-value={value}>
      <Stack direction='row' spacing={1.5}>
        <Typography textAlign='left' lineHeight='20px'>
          {`${value} ${t('common:dates.days')}`}
        </Typography>
        {value < 0 ? <WarningIcon /> : null}
      </Stack>
      <Typography
        fontSize={12}
        textAlign='left'
        lineHeight='14px'
        color={semantic.color.text.muted}
      >
        {value < 0
          ? t('issue:view.sla.labels.overdue')
          : t('issue:view.sla.labels.remaining')}
      </Typography>
    </Box>
  );
}
